import { render, staticRenderFns } from "./subscription-category-table.vue?vue&type=template&id=c5356be4&scoped=true&"
import script from "./subscription-category-table.ts?vue&type=script&lang=ts&"
export * from "./subscription-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./subscription-category-table.scss?vue&type=style&index=0&id=c5356be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5356be4",
  null
  
)

export default component.exports